import React from "react";
import StyledPage from "./StyledPage";
import "../style/main-page.css";
import DiffBg from "../assets/difference-bg.png";
import PriceBg from "../assets/price-bg.png";
import Content2 from "../assets/frame2_diff.png";
import Price from "../assets/price.png";
import Price2 from "../assets/price-2.png";
import Price3 from "../assets/price-3.png";
import TimeTable from "../assets/timetable.png";
import Notice from "../assets/notice.png";
import InquiryForm from "../components/InquiryForm";

const MainPage = () => {
  return (
    <StyledPage>
      <div className={'main-pg'}>
        {/* 첫번째 페이지 */}
        <div className={'main-first-frame'}>
          <div className={'main-sub-title'}>
            가족과 함께, <br/>
            <span style={{color: '#052759'}}>즐겁고 안전한</span> 겨울 스포츠의 시작
          </div>
          <div className={'main-title'}>블루스키</div>
        </div>

        {/* 두번째 페이지 */}
        <div className={'main-second-frame'}>
          <img className={'main-second-bg'} src={DiffBg} alt={''}/>
          <div className={'text-sm'}>일반 스키 팀은 따라올 수 없는</div>
          <div className={'text-md'}>
            <span style={{fontSize: '4vw', color: '#253956', fontWeight: 800}}>맞춤형 케어</span>를 제공합니다
          </div>
          <img className={'main-second-content'} src={Content2} alt={''}/>
        </div>

        {/*세번째 페이지*/}
        <div className={'main-third-frame'}>
          <img className={'main-third-bg'} src={PriceBg} alt={''}/>
          <div className={'main-third-content'}>
            <img className={'main-third-content-1'} src={Price} alt={''}/>
            <img className={'main-third-content-2'} src={Price2} alt={''}/>
            <img className={'main-third-content-3'} src={Price3} alt={''}/>
          </div>
        </div>

        {/*네번쨰 페이지*/}
        <div className={'main-fourth-frame'}>
          <img className={'main-fourth-content'} src={TimeTable} alt={''}/>
          <img className={'main-fourth-content'} src={Notice} alt={''}/>
        </div>

        {/*실시간 문의 페이지*/}
        <div className={'main-inquiry-frame'}>
          <div className={'main-inquiry-title'}>실시간 문의</div>
            <InquiryForm/>
        </div>
      </div>
    </StyledPage>
  );
};

export default MainPage;